import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import select from 'select-dom'

Vue.component('cart-gift-message', {
  data () {
    return {
      open: false
    }
  },
  created () {
    if (this.giftMessage) {
      this.open = this.giftMessage
    }
  },
  computed: {
    ...mapGetters(['giftMessage'])
  },
  methods: {
    ...mapActions(['updateGiftMessage']),
    onMessageUpdate (event) {
      this.updateGiftMessage(event.target.value)
    },
    openNote () {
      this.open = !this.open
      const noteEl = select('#textinputgiftmessage')
      setTimeout(() => {
        if (this.open && noteEl) {
          noteEl.focus({preventScroll: true})
        }
      }, 4)
    }
  }
})
